<template>
  <div>
    <Navbar />
    <div class="container mt-3">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-4">
            <h4 class="title">Gracias por confiar en Valor Latino</h4>
            <p class="text-justify" v-if="modelo !== ''">
              Para proporcionarte la propuesta de renovación de tu vehículo
              <span style="font-weight: bold;">{{ modelo }} {{ anio }}</span>, ayúdanos con la siguiente información.
            </p>
            <h4 class="title">Datos del conductor habitual</h4>
            <p class="text-justify">
              ¿Los datos del conductor habitual son los mismos?
            </p>
            <div v-if="nombreCompleto !== ''">
              <Input :forLabel="'nombreCompleto'" :label="'Nombre completo'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'nombreCompleto'" :required="true" :disabled="isEnablePersonalForm"
                :value.sync="nombreCompleto" />
              <Input :classParent="'mt-3'" :forLabel="'apellidoPaterno'" :label="'Apellido paterno'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'apellidoPaterno'" :required="true"
                :disabled="isEnablePersonalForm" :value.sync="apellidoPaterno" />
              <Input :classParent="'mt-3'" :forLabel="'apellidoMaterno'" :label="'Apellido materno'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'apellidoMaterno'" :required="true"
                :disabled="isEnablePersonalForm" :value.sync="apellidoMaterno" />
              <Input :classParent="'mt-3'" :forLabel="'fechaNacimiento'" :label="'Fecha de nacimiento'"
                :typeInput="'date'" :classInput="'form-control'" :idInput="'fechaNacimiento'" :required="true"
                :disabled="isEnablePersonalForm" :value.sync="fechaNacimiento" />
              <Input :classParent="'mt-3'" :forLabel="'codigoPostal'" :label="'Codigo Postal'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'codigoPostal'" :required="true" :disabled="isEnablePersonalForm"
                :value.sync="codigoPostal" />

              <div class="form-group mt-3">
                <label class="font-label">Sexo</label>
                <select name="version" class="form-control" :disabled="isEnablePersonalForm" v-model="sexo">
                  <option value="0">-- Selecciona</option>
                  <option :value="sex.value" v-for="(sex, i) in sexoArray" :key="i">
                    {{ sex.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <button class="btn btn-rounded mr-2" :class="btnPersonalEstatus === 1
                  ? 'btn-primary'
                  : 'btn-outline-primary'
                  " @click="btnPersonalEstatus = 1">
                  Si
                </button>
                <button class="btn btn-rounded" :class="btnPersonalEstatus === 2
                  ? 'btn-primary'
                  : 'btn-outline-primary'
                  " @click="
    enablePersonalForm();
  btnPersonalEstatus = 2;
  ">
                  No
                </button>
              </div>
            </div>
            <hr />
            <h4 class="title">Agrega un plus a tu protección</h4>
            <p class="text-justify">
              Selecciona si deseas agregar más protección a tu seguro.
            </p>
            <HorizontalMenu v-if="cobsScroll.length > 0" :cobs="cobsScroll" :formatMoney="formatMoney"
              :updateSumaCobertura="updateSumaCobertura" />
            <p>Desliza hacia la izquierda para conocer nuestras asistencias</p>
            <hr />
            <!--<h4 class="title">Verificación de kilometraje</h4>
            <p class="text-justify">
              Para proporcionarte el costo de tu póliza por favor confirma el
              kilometraje.
            </p>
            <Input :classParent="'mt-1'" :forLabel="'kilometraje'" :label="'Confirmación kilometraje'"
              :typeInput="'number'" :classInput="'form-control border'" :idInput="'kilometraje'" :required="true"
              :disabled="false" :value.sync="kilometraje" />-->
            <h4 class="title mt-3">Proceso de inspección</h4>
            <p class="text-justify">
              Realiza tu inspección capturando las fotografias que solicitamos.
              Da click en el botón y sigue las instrucciones e imágen(es) de
              referencia.
            </p>
            <p class="text-justify">
              Es importante que se encuentren legibles y completas, en caso de
              tener alguna duda te puedes contactar al:
            </p>
            <p class="text-center">
              55 5130 2800 Ext. 1637
            </p>
            <hr />
            <div v-if="estatusRenovacion === '0'" id="preview" class="text-center">
              <img class="img-fluid mt-3" :src="photo.preview" />
              <img v-if="photo.preview === ''" class="img-fluid mt-3" src="./assets/images/inspeccion/0007.png" />
              <p class="mt-3">
                Toma la fotografía del odómetro
                <strong>con el vehículo y motor encendido</strong> como se
                muestra en la imagen
              </p>
              <span class="btn btn-outline-primary btn-file btn-rounded mt-1">
                <i class="fas fa-camera"></i> Tomar fotografía
                <input type="file" class="form-control" @change="onFileChange" capture required />
              </span>
            </div>
            <div v-if="estatusRenovacion === '1'" id="preview" class="text-center">
              <HorizontalPhotos :photos="photos" :onFileChange="onFileChangeMultiple" />
              <p class="mt-3 title">
                Desliza hacia la izquierda para poder tomar las demás fotos
              </p>
            </div>
            <h4 class="title mt-3">¡Ya casi terminamos!</h4>
            <p class="text-justify">
              ¿Los datos del Contratante (quien paga la póliza) se han
              modificado?
            </p>
            <div class="row mt-2">
              <div class="col-md-12 text-center">
                <button class="btn btn-rounded mr-2" :class="btnContractEstatus === 1
                  ? 'btn-primary'
                  : 'btn-outline-primary'
                  " @click="
    isEnableContractForm = false;
  polizaForm = 1;
  btnContractEstatus = 1;
  ">
                  Si
                </button>
                <button class="btn btn-rounded" :class="btnContractEstatus === 2
                  ? 'btn-primary'
                  : 'btn-outline-primary'
                  " @click="
    isEnableContractForm = true;
  polizaForm = 1;
  btnContractEstatus = 2;
  ">
                  No
                </button>
              </div>
            </div>
            <div v-if="nombreCompletoPoliza !== ''" class="poliza-form">
              <div class="mt-2">
                <label for="tipo">Tipo de persona</label>
                <select name="tipoPersona" id="tipo" class="form-control" v-model="tipoPersona"
                  :disabled="isEnableContractForm" @change="catalogoRegimenFiscal()">
                  <option value="0">--- Seleccionar</option>
                  <option v-for="item in tipoPersonaArray" :value="item.value">{{ item.label }}</option>
                </select>
              </div>
              <Input :classParent="'mt-3'" :forLabel="'nombreCompletoPoliza'"
                :label="tipoPersona === 1 ? 'Nombre completo' : 'Razón social'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'nombreCompletoPoliza'" :required="true"
                :disabled="isEnableContractForm" :value.sync="nombreCompletoPoliza" />
              <Input v-if="tipoPersona === 1" :classParent="'mt-3'" :forLabel="'apellidoPaterno'"
                :label="'Apellido paterno'" :typeInput="'text'" :classInput="'form-control'" :idInput="'apellidoPaterno'"
                :required="true" :disabled="isEnableContractForm" :value.sync="apellidoPaternoPoliza" />
              <Input v-if="tipoPersona === 1" :classParent="'mt-3'" :forLabel="'apellidoMaterno'"
                :label="'Apellido materno'" :typeInput="'text'" :classInput="'form-control'" :idInput="'apellidoMaterno'"
                :required="true" :disabled="isEnableContractForm" :value.sync="apellidoMaternoPoliza" />
              <label for="" class="mt-3">R.F.C</label>
              <div class="input-group">
                <input type="text" class="form-control" v-model="rfc" maxlength="13" @keypress="clsAlphaNoOnly"
                  :disabled="isEnableContractForm" required />
                <button v-if="tipoPersona === 1" class="btn btn-danger font-label" type="button"
                  :disabled="isEnableContractForm" @click="consultaSiglasRFC()">
                  Consultar
                </button>
              </div>
              <Input :classParent="'mt-3'" :forLabel="'fechaNacimiento'" :label="'Fecha de nacimiento'"
                :typeInput="'date'" :classInput="'form-control'" :idInput="'fechaNacimiento'" :required="true"
                :disabled="isEnableContractForm" :value.sync="fechaNacimientoPoliza" />
              <Input :classParent="'mt-3'" :forLabel="'calle'" :label="'Calle'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'calle'" :required="true" :disabled="isEnableContractForm"
                :value.sync="calle" />
              <div class="row">
                <div class="col">
                  <Input :classParent="'mt-3'" :forLabel="'numeroExterior'" :label="'Numero exterior'"
                    :typeInput="'number'" :classInput="'form-control'" :idInput="'numeroExterior'" :required="true"
                    :disabled="isEnableContractForm" :value.sync="numExterior" />
                </div>
                <div class="col">
                  <Input :classParent="'mt-3'" :forLabel="'numeroInterior'" :label="'Numero interior'"
                    :typeInput="'number'" :classInput="'form-control'" :idInput="'numeroInterior'" :required="true"
                    :disabled="isEnableContractForm" :value.sync="numInterior" />
                </div>
              </div>
              <div class="mt-3">
                <label class="font-label">Colonia</label>
                <select class="form-control" v-model="colonia" :disabled="isEnableContractForm" required>
                  <option v-for="(col, i) in colonias" :key="i" :value="col.colonia">
                    {{ col.colonia }}
                  </option>
                </select>
              </div>
              <div class="mt-3">
                <label for="codigoPostal">Código postal</label>
                <input type="number" class="form-control" id="codigoPostal" v-model="codigoPostalPoliza" required="true"
                  :disabled="isEnableContractForm" @keyup="handleCP" />
              </div>
              <div class="mt-3">
                <label for="alcaldia">Alcaldía o Municipio</label>
                <input type="text" class="form-control" id="alcaldia" v-model="municipio" required="true"
                  disabled="true" />
              </div>
              <div class="mt-3">
                <label for="estado">Estado</label>
                <input type="text" class="form-control" id="estado" v-model="estado" required="true" disabled="true" />
              </div>
              <Input :classParent="'mt-3'" :forLabel="'telefono'" :label="'Teléfono'" :typeInput="'text'"
                :classInput="'form-control'" :idInput="'telefono'" :required="true" :disabled="isEnableContractForm"
                :value.sync="telefono" />
              <Input :classParent="'mt-3'" :forLabel="'Correoelectronico'" :label="'Correo electrónico'"
                :typeInput="'text'" :classInput="'form-control'" :idInput="'Correoelectronico'" :required="true"
                :disabled="isEnableContractForm" :value.sync="correo" />
              <div class="form-group mt-3">
                <label class="font-label">Régimen fiscal</label>
                <select name="version" class="form-control" :disabled="isEnableContractForm" v-model="regimenFiscal">
                  <option value="0">-- Selecciona</option>
                  <option :value="cat.ID_FACT_REG_FISCAL" v-for="(cat, i) in catRegimenFiscal" :key="i">
                    {{ cat.DESCT_REG_FISCAL }}
                  </option>
                </select>
              </div>
            </div>
            <div class="text-center mt-3">
              <button class="btn btn-primary btn-rounded" @click="validate()" :disabled="enableConfirmButton">
                Confirmar nuevos datos
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <ModalDispositivoNoPermitido />
    <ModalLigaCaducada />
    <ModalPolizaConcluido />
    <ModalAvisoPrivacidad />
    <ModalEdicionCampos />
    <ModalCambioPaquete :paquetes="paquetes" :guardarCambios.sync="isModifyDataPoliza" />
    <ModalExito />

    <loading></loading>
  </div>
</template>
<script>
import Loading from "../../componentes/ImgLoading/loading.vue";

import Navbar from "./tools/Navbar.vue";
import Input from "./tools/Input.vue";
import Select from "./tools/Select.vue";

import HorizontalMenu from "./tools/HorizontalMenu.vue";
import HorizontalPhotos from "./tools/HorizontalPhotos.vue";

import ModalDispositivoNoPermitido from "./modals/ModalDispositivoNoPermitido.vue";
import ModalLigaCaducada from "./modals/ModalLigaCaducada.vue";
import ModalPolizaConcluido from "./modals/ModalPolizaConcluido.vue";
import ModalAvisoPrivacidad from "./modals/ModalAvisoPrivacidad.vue";
import ModalEdicionCampos from "./modals/ModalEdicionCampos.vue";
import ModalCambioPaquete from "./modals/ModalCambioPaquete.vue";
import ModalExito from "./modals/ModalExito.vue";

import { format, extensionImage, date } from "./../../assets/helpers/index";

export default {
  components: {
    Navbar,
    Input,
    Select,
    HorizontalMenu,
    HorizontalPhotos,
    ModalDispositivoNoPermitido,
    ModalLigaCaducada,
    ModalPolizaConcluido,
    ModalAvisoPrivacidad,
    ModalEdicionCampos,
    ModalCambioPaquete,
    ModalExito,
    Loading,
  },
  data: function () {
    return {
      // general
      polizaMain: "",
      estatusRenovacion: "",
      latitud: "",
      longitud: "",
      enableConfirmButton: false,
      modelo: "",
      anio: "",
      btnPersonalEstatus: 0,
      btnContractEstatus: 0,

      // modals
      avisoPrivacidad: true,

      // personal form
      isEnablePersonalForm: true,
      nombreCompleto: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      fechaNacimiento: "",
      codigoPostal: "",
      sexoArray: [
        {
          label: "MASCULINO",
          value: "MASCULINO",
        },
        {
          label: "FEMENINO",
          value: "FEMENINO",
        },
      ],
      sexo: "",
      entidad: "",

      // kilometraje y fotos
      photos: [
        {
          photo: "",
          base: "",
          default: "0001.png",
          code: "0001",
          descrip:
            "Toma la fotografía de tu vehículo como se indica (diagonal frontal izquierda). <strong>La placa debe de ser visible. Para tomar la siguiente desliza a la izquierda.</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0002.png",
          code: "0002",
          descrip:
            "Toma la fotografía de tu vehículo como se indica (diagonal frontal derecha). <strong>La placa debe de ser visible.</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0003.png",
          code: "0003",
          descrip:
            "Toma la fotografía de tu vehículo como se indica (diagonal trasera izquierda). <strong>La placa debe de ser visible.</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0004.png",
          code: "0004",
          descrip:
            "Toma la fotografía de tu vehículo como se indica (diagonal trasera derecha). <strong>La placa debe de ser visible.</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0005.png",
          code: "0005",
          descrip:
            "Toma la fotografía de tarjeta de circulación como se indica. <strong>Los datos deben de ser visibles.</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0006.png",
          code: "0006",
          descrip:
            "Toma la fotografía del número VIN de tu auto. <strong>Enfoca bien el número de serie</strong>",
        },
        {
          photo: "",
          base: "",
          default: "0007.png",
          code: "0007",
          descrip:
            "Toma la fotografía del odómetro <strong>con el vehículo y motor encendido</strong> como se muestra en la imagen",
        },
        {
          photo: "",
          base: "",
          default: "0008.png",
          code: "0008",
          descrip:
            "Toma la fotografía del tablero <strong>con el vehículo y motor encendido.</strong> Es importante que se muestre el parabrisas completo.",
        },
        {
          photo: "",
          base: "",
          default: "0009.png",
          code: "0009",
          descrip:
            "Toma la fotografía de tu identificación oficial como se indica. <strong>Los datos deben de ser visibles.</strong>",
        },
      ],
      photo: {
        code: "0007",
        preview: "",
        base: "",
      },
      kilometraje: 0.01,

      // poliza form
      idCliente: 0,
      isEnableContractForm: true,
      polizaForm: 0,
      tipoPersona: 0,
      tipoPersonaArray: [
        {
          label: "Persona Fisica",
          value: 1,
        },
        {
          label: "Persona Moral",
          value: 2,
        },
      ],
      catRegimenFiscal: [],
      nombreCompletoPoliza: "",
      apellidoPaternoPoliza: "",
      apellidoMaternoPoliza: "",
      rfc: "",
      fechaNacimientoPoliza: "",
      calle: "",
      numExterior: "",
      numInterior: "",
      colonias: [],
      colonia: "",
      codigoPostalPoliza: "",
      municipio: "",
      estado: "",
      telefono: "",
      correo: "",
      regimenFiscal: 0,

      // coberturas
      allCobsUser: [],
      allCobs: [],
      cobsScroll: [],
      selectedPlan: 0,
      payload: {},

      cotizacion: [],
      poliza: [],
      universe: "",
      porcentaje: "",
      total: 0,

      // paquetes
      paquetes: [],
    };
  },
  methods: {
    formatInputDate(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    validate() {
      const isValidatePhoto = this.photo.base === "";
      const isValidatePhotos = this.photos.findIndex(
        (photo) => photo.base === ""
      );
      
      console.log(isValidatePhotos)
      this.enviarBitacora("se confirma el envío de fotos y la cotización de la póliza: " + this.polizaMain + " fotos enviadas");

      if (this.estatusRenovacion === "0" && isValidatePhoto) {
        this.$swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: 'ES NECESARIO TOMAR LA FOTOGRAFIA DEL VEHICULO',
        });
        return;
      }

      if (this.estatusRenovacion === "1" && isValidatePhotos > -1) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "ES NECESARIO TOMAR LA FOTO NÚMERO: " + (isValidatePhotos + 1),
        });
        return;
      }

      /*if (
        this.kilometraje < +this.poliza.INCISO[0].KILOMETRAJE 
        //|| this.kilometraje === ""
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "EL KILOMETRAJE QUE INGRESA ES MENOR AL DE LA POLIZA ANTERIOR",
        });
        return;
      }*/

      this.getLocation();
    },
    getLocation() {
      this.enableConfirmButton = true;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;

          this.getObtenerPaquetesRenovacion();
        },
        (_) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Es necesario aceptar los permisos para la ubicación",
          });

          this.enableConfirmButton = false;

        }
      );
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        // Create file reader
        let reader = new FileReader();

        // Register event listeners
        reader.addEventListener("loadend", (e) => resolve(e.target.result));
        reader.addEventListener("error", reject);

        // Read fileyj
        reader.readAsArrayBuffer(file);
      });
    },
    resetPhotos() {
      this.photos = [];
    },
    enablePersonalForm() {
      document.getElementById("btnEdicionCamposPersonales").click();
      this.isEnablePersonalForm = false;
    },
    cerrarModal(){
      this.enviarBitacora("acepta aviso de privacidad: " + this.polizaMain);
      $("#avisoPrivacidadModal").modal("hide");
    },
    filterCoberturas() {
      let plan = [];

      plan = this.allCobs.find(
        (cobs) => cobs.PAQUETE === this.poliza.INCISO[0].PAQUETE
      );

      plan.COBERTURAS.map((p) => {
        const exists = this.allCobsUser.find(
          (cob) => cob.NOMENCLATURA === p.NOMENCLATURA
        );
        p.check = exists !== undefined;
      });

      return plan.COBERTURAS.filter(
        (cob) => cob.OPCIONAL === 1 && cob.TIPO === 2
      );
    },
    formatMoney(amount) {
      if (isNaN(amount)) {
        return amount;
      }
      return format.money(amount, false);
    },
    updateSumaCobertura(check, nomenclatura, deducible, suma, prima) {
      const asis = this.cobsScroll.find(
        (cob) => cob.NOMENCLATURA === nomenclatura
      );

      if (check) {
        this.total = prima + this.total;
      } else {
        this.total = this.total - prima;
      }

      asis.check = check;
    },
    clsAlphaNoOnly(e) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(str)) {
        return true;
      }

      e.preventDefault();
      return false;
    },
    formatDateBirthday(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join("/");
    },
    isModifyDataPoliza(items) {
      this.btnContractEstatus === 1
        ? this.guardarClienteUnicoEmitir(items)
        : this.guardarCambios(items);
    },
    // endpoints
    async getMobileOperatingSystem() {
      const userAgent = navigator.userAgent;
      this.enviarBitacora("valida el dispositivo " + userAgent);

      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      ) {
        document.getElementById("btnAvisoPrivacidadModal").click();
        await this.login();
      } else {
        document.getElementById("btnDispositivoNoPermitido").click();
      }
    },
    async login() {
      await this.$store.dispatch("loginValorLatino", {
        userName: "900650",
        password: "123456",
      });
      this.enviarBitacora("otiene token para los servicios: " + localStorage.getItem("token"));

      await this.validarTokenRenovacion();
    },
    async getCobs() {
      const payload = {
        metodo: "OBTENERCOBERTURASASISTENCIAS",
        data: {
          clavePaquete: this.poliza.INCISO[0].CVPAQUETE,
          ClaveVehiculo: this.poliza.INCISO[0].CVVEHICULO,
          ModeloVehiculo: this.poliza.INCISO[0].MODELO,
          claveAgente: localStorage.getItem("userId"),
          claveCotizador: "2",
          claveRamo: this.poliza.RAMO,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then((_) => {
        const planes = this.$store.getters.getRespuestaREST;

        planes[0].COBERTURAS.map((cob) => {
          this.cobsScroll.push({
            ...cob,
            check:
              this.allCobsUser.find(
                (cobUser) => cobUser.NOMENCLATURA === cob.NOMENCLATURA
              ) !== undefined,
          });
        });
      });
    },
    async cargarCotizacionDatos() {
      const payload = {
        metodo: "OBTIENEGUARDADOCOTIZACION",
        data: {
          CLIENTE: {},
          INCISOS: [
            {
              COBERTURAS: [{}],
            },
          ],
          COTIZACION: "",
          POLIZA: this.polizaMain,
        },
      };

      this.enviarBitacora("obtiene datos básicos de la póliza anterior: " + this.polizaMain);

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        this.cotizacion = response[0];

        this.fechaNacimiento =
          this.formatInputDate(
            new Date(
              format.date(response[0].CLIENTE.FECHANACIMIENTO, "aaaa/mm/dd")
            ),
            0
          ) || "";

        this.fechaNacimientoPoliza =
          this.formatInputDate(
            new Date(
              format.date(response[0].CLIENTE.FECHANACIMIENTO, "aaaa/mm/dd")
            ),
            0
          ) || "";

        await this.consultarPoliza(
          response[0].RAMO,
          response[0].POLIZA,
          response[0].INCISOS[0].INCISO
        );
      }
    },
    async consultarPoliza(ramo, poliza, inciso) {
      const payload = {
        metodo: "CONSULTARPOLIZA",
        data: {
          RAMO: ramo,
          NumPoliza: poliza,
          NumInciso: inciso,
          TIPOENDOSO: "",
        },
      };

      this.enviarBitacora("obtiene datos de la poliza anterior que se está venciendo: " + poliza);

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        if (response[0].ESTATUSRENOVACION === "0") {
          this.enviarBitacora("renovación de póliza concluida: " + poliza + " estatus: " + response[0].ESTATUSRENOVACION);
          document.getElementById("btnPolizaConcluido").click();
          return;
        }

        this.poliza = response[0];

        this.nombreCompleto = response[0].CONDUCTOR.NOMBRE;
        this.apellidoPaterno = response[0].CONDUCTOR.APELLIDOPATERNO;
        this.apellidoMaterno = response[0].CONDUCTOR.APELLIDOMATERNO;
        this.codigoPostal = response[0].CONDUCTOR.CODIGOPOSTAL;
        this.sexo = response[0].CONDUCTOR.SEXO;

        this.nombreCompletoPoliza = response[0].ASEGURADO[0].NOMBRECORTO;
        this.apellidoPaternoPoliza = response[0].ASEGURADO[0].APELLIDOPATERNO;
        this.apellidoMaternoPoliza = response[0].ASEGURADO[0].APELLIDOMATERNO;
        this.telefono = response[0].ASEGURADO[0].TELEFONO;
        this.correo = response[0].ASEGURADO[0].CORREO;
        this.numExterior = response[0].ASEGURADO[0].NUMEROEXTERIOR;
        this.numInterior = response[0].ASEGURADO[0].NUMEROINTERIOR;
        this.rfc = response[0].ASEGURADO[0].RFC;
        this.calle = response[0].ASEGURADO[0].DIRECCION;
        this.colonia = response[0].ASEGURADO[0].COLONIA;
        this.codigoPostalPoliza = response[0].ASEGURADO[0].CODIGOPOSTAL;
        this.correo = response[0].ASEGURADO[0].CORREO;
        this.tipoPersona = +response[0].ASEGURADO[0].CVPERSONA;
        this.regimenFiscal = +response[0].ASEGURADO[0].REGIMENFISCAL;

        this.getInfoCp(response[0].ASEGURADO[0].CODIGOPOSTAL);

        this.universe = response[0].ESTADOUNIVERSE;

        this.modelo = response[0].INCISO[0].MARCA;
        this.anio = response[0].INCISO[0].MODELO;

        this.allCobsUser.push(...response[0].INCISO[0].COBERTURASASEGURADAS);

        await this.catalogoRegimenFiscal();
        await this.getCobs();
      }
    },
    async consultaSiglasRFC() {
      if (
        (this.tipoPersona === 1 &&
          this.nombreCompletoPoliza !== "" &&
          this.apellidoPaternoPoliza !== "" &&
          this.apellidoMaternoPoliza !== "") ||
        (this.tipoPersona === 2 && this.nombreCompletoPoliza !== "")
      ) {
        const payload = {
          metodo: "CONSULTASIGLASRFC",
          data: {
            Nombre: this.nombreCompletoPoliza,
            ApellidoPaterno:
              this.tipoPersona === 2 ? "" : this.apellidoPaternoPoliza,
            ApellidoMaterno:
              this.tipoPersona === 2 ? "" : this.apellidoMaternoPoliza,
            Fecha: this.formatDateBirthday(
              new Date(this.fechaNacimientoPoliza),
              1
            ),
            Tipo: this.tipoPersona.toString(),
          },
        };

        await this.$store
          .dispatch("metodoPost", payload)
          .then(() => {
            const response = this.$store.getters.getRespuestaREST;
            this.rfc = response;
          })
          .catch((error) => {
            console.log(["Error", error]);
          });
      } else {
        this.$swal.fire({
          title: "Es necesario llenar los campos de nombre y apellidos",
        });
      }
    },
    async catalogoRegimenFiscal() {
      this.catRegimenFiscal = [];

      const payload = {
        metodo: "CATALOGOREGIMENFISCAL",
        data: {
          TipoPersona: this.tipoPersona,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.catRegimenFiscal.push(...response);
      }
    },
    async validarTokenRenovacion() {
      const payload = {
        metodo: "VALIDARTOKENRENOVACION",
        data: {
          sToken: this.$route.query.token,
        },
      };

      this.enviarBitacora("valida token de renovación: " + this.$route.query.token);

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getDataRaw.data;

        if (response.flag) {
          this.polizaMain = response.data.NUMEROPOLIZA;
          this.estatusRenovacion = response.data.ESTATUSRENOVACION;
          await this.cargarCotizacionDatos();
        } else {
          this.enviarBitacora("liga caducada para su renovación: " + this.$route.query.token);
          document.getElementById("btnLigaCaduca").click();
        }
      }
    },
    async getPorcentajeDescuento() {
      let porcentaje = "";

      if (this.isEnablePersonalForm) {
        await this.poliza.DESCUENTOS.map((desc, i) => {
          if (i === 0) {
            porcentaje = `${desc.ValorInicio}`;
          } else {
            porcentaje = `${porcentaje} - ${desc.ValorInicio}`;
          }
        });

        return porcentaje;
      } else {
        return this.porcentaje;
      }
    },
    async getObtenerPaquetesRenovacion() {
      this.paquetes = [];

      if (!this.isEnablePersonalForm) {
        await this.obtenerInfoCP();
        await this.obtenerDescuentos();
      }

      this.kilometraje = this.poliza.INCISO[0].KILOMETRAJE;

      const payload = {
        metodo: "OBTENERPAQUETESRENOVACION",
        data: {
          ClaveVehiculo: this.poliza.INCISO[0].CVVEHICULO,
          ModeloVehiculo: this.poliza.INCISO[0].MODELO,
          ClaveAgente: localStorage.getItem("userId"),
          ClaveCotizador: "2",
          ValorAuto: "0",
          EstadoUniverse: this.universe,
          PorcentajeDescuento: await this.getPorcentajeDescuento(),
          Kilometraje: this.kilometraje,
          //Kilometraje: this.poliza.INCISO[0].KILOMETRAJE,
          VigenciaInicio: this.poliza.INIVIGENCIA,
          VigenciaFin: this.poliza.FINVIGENCIA,
          TipoVigencia: this.poliza.TIPOVIGENCIA,
          TipoValor: "",
          BuroCredito: "",
          ClavePaquete: this.poliza.INCISO[0].CVPAQUETE,
          NombrePaquete: this.poliza.INCISO[0].PAQUETE,
          ClaveRamo: this.poliza.RAMO,
          CVFormaPago: this.poliza.CVFORMAPAGO,
          Coberturas: [
            ...this.poliza.INCISO[0].COBERTURASASEGURADAS,
            ...(await this.cobsScroll.filter((cob) => cob.check)),
          ],
          NumeroPoliza: this.polizaMain,
          KilometroAnterior: this.poliza.INCISO[0].KILOMETRAJE,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then((_) => {
        const response = this.$store.getters.getRespuestaREST;
        this.paquetes.push(...response);
        document.getElementById("btnCambioDePaquete").click();
        this.enableConfirmButton = false;
        this.guardarCambios({
                      gastos: this.paquetes[0].GASTOSEXPEDICION,
                      paquete: this.paquetes[0].TIPOPAQUETE,
                      iva: this.paquetes[0].IVA,
                      primaneta: this.paquetes[0].PRIMANETA,
                      recargo: this.paquetes[0].RECARGO,
                      subtotal: this.paquetes[0].SUBTOTAL,
                      primatotal: this.paquetes[0].PRIMATOTAL,
                      coberturas: this.paquetes[0].COBERTURAS,
                    })
      });
    },
    async getCoberturas(coberturas) {
      const cobs = [];

      await coberturas.map((cob) => {
        cobs.push({
          CLAVECOBERTURA: cob.NOMENCLATURA,
          DEDUCIBLE: cob.DEDUDEFAULT,
          PRIMACOBERTURA: cob.PRIMA,
          SUBRAMO: "",
          SUMAASEGURADA: cob.SUMADEFAULT,
        });
      });

      return cobs;
    },
    async getSumaAseguradaCoberturas() {
      let suma = 0;

      await this.poliza.INCISO[0].COBERTURASASEGURADAS.map(
        (cob) => (suma = suma + cob.SUMADEFAULT)
      );

      return suma;
    },
    async guardarCambios({
      gastos,
      paquete,
      iva,
      primaneta,
      recargo,
      subtotal,
      primatotal,
      coberturas,
    }) {
      const payload = {
        metodo: "GUARDARCOTIZACIONRENOVACION",
        data: {
          AGENTE: this.poliza.CVAGENTE,
          CLIENTE: {
            CORREO: !this.isEnableContractForm ? this.correo : this.poliza.CONDUCTOR.CORREO,
            CP: this.codigoPostal,
            FECHANACIMIENTO: this.formatDateBirthday(
              new Date(this.fechaNacimiento),
              1
            ),
            IDCLIENTE:
              this.btnContractEstatus === 1
                ? this.idCliente
                : this.poliza.ASEGURADO[0].NUMEROCLIENTE,
            NOMBRE: `${this.nombreCompleto}|${this.apellidoPaterno}|${this.apellidoMaterno}`,
            SEXO: this.sexo,
            TELEFONO: this.telefono,
          },
          COTIZACION: "",
          ENTIDAD: this.entidad,
          FECHAALTA: this.poliza.FECHAEMISION,
          FECHAINSPECION: "",
          FP: this.poliza.CVFORMAPAGO,
          GASTOS: gastos,
          INCISOS: [
            {
              BENEFICIARIO: "",
              CLAVE: this.poliza.INCISO[0].CVVEHICULO,
              COBERTURAS: [...(await this.getCoberturas(coberturas))],
              CONDUCTOR: `${this.nombreCompleto} ${this.apellidoPaterno} ${this.apellidoMaterno}`,
              CONTROLVEHICULAR: "",
              FAMILIAR: {
                ALCALDIA: "",
                COLONIA: "",
                DIRECCION: "",
                ESTADO: "",
                EXTERIOR: "",
                INTERIOR: "",
                POSTAL: "",
              },
              FECHAFACTURA: "",
              KILOMETRAJE: this.kilometraje,
              MODELO: this.poliza.INCISO[0].MODELO,
              MOTOR: this.poliza.INCISO[0].MOTOR,
              PLACAS: this.poliza.INCISO[0].PLACA,
              SAVEHICULO: 0,
              SERIE: this.poliza.INCISO[0].SERIE,
              TIPOCARGA: "",
              TIPOPAQUETE: paquete,
              VALORNUEVO: 0,
            },
          ],
          IVA: iva,
          MONEDA: 0,
          POLIZA: "",
          PRIMANETA: primaneta,
          RECARGOS: recargo,
          SUBTOTAL: subtotal,
          SUMAASEGURADA: await this.getSumaAseguradaCoberturas(),
          TOTAL: primatotal,
          USUARIO: localStorage.getItem("userId"),
          VIGENCIAFIN: this.poliza.FINVIGENCIA,
          VIGENCIAINI: this.poliza.INIVIGENCIA,
          POLIZARENOVADA: this.poliza.NUMPOLIZA,
          MARCA: this.poliza.INCISO[0].MARCA,
          SUBMARCA: this.poliza.INCISO[0].SUBMARCA,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(() => {
        const res = this.$store.getters.getRespuestaREST;
        this.preparePhotos(res.COTIZACION);
      });
    },
    async obtenerInfoCP() {
      const payload = {
        metodo: "OBTENERINFORMACIONCP",
        data: {
          cp: this.codigoPostal,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const address = this.$store.getters.getRespuestaREST[0];

        if (address !== undefined) {
          this.universe = address.MunUniverse || address.Universe;
        }
      }
    },
    handleCP(e) {
      const cp = e.target.value;

      if (isNaN(cp)) {
        this.$swal.fire({
          title: "Sólo números son permitidos",
        });
        e.target.value = cp.slice(0, -1);
        return;
      }

      if (cp.length == 5) {
        this.getInfoCp(cp);
      }
    },
    async getInfoCp(cp) {
      this.colonias = [];

      const payload = {
        metodo: "OBTENERINFORMACIONCP",
        data: {
          cp: cp,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const address = this.$store.getters.getRespuestaREST;

        this.estado = address[0].NombreEstado;
        this.municipio = address[0].NombreMunicpio;
        // this.delegacion = address.NombreCiudad;
        this.entidad = address[0].MunUniverse == "" ? address[0].Universe : address[0].MunUniverse;
        // this.universe2 = address.Universe;

        this.$store.getters.getRespuestaREST.map((dir) => {
          this.colonias.push({
            clave: dir.ClaveColonia,
            colonia: dir.NombreColonia,
          });
        });
      }
    },
    async obtenerDescuentos() {
      const payload = {
        metodo: "OBTENERDESCUENTOS",
        data: {
          Genero: this.sexo === "MASCULINO" ? "M" : "F",
          Edad: date.getAge(format.date(this.fechaNacimiento, "aaaa/mm/dd")),
          ClaveVehiculo: this.poliza.INCISO[0].CVVEHICULO,
          Kilometraje: this.kilometraje,
        },
      };

      await this.$store.dispatch("metodoPost", payload);
      const descuentos = this.$store.getters.getRespuestaREST.map(
        (descuento) => descuento.ValorInicio
      );
      this.porcentaje = descuentos.join("-");
    },
    async onFileChange(e) {
      const file = e.target.files[0];

      const blob = file.slice(
        0,
        file.size,
        extensionImage.getExtension(file.type)
      );
      const newFile = new File(
        [blob],
        `${this.poliza.RAMO}${this.poliza.NUMPOLIZA}-${this.photo.code}.jpeg`
      );

      this.enviarBitacora("Capturando fotos de la cámara");
      this.enviarBitacora(newFile);

      this.photo.preview = URL.createObjectURL(file);
      this.photo.base = newFile;
    },
    async getAsByteArray(file) {
      return new Uint8Array(await this.readFile(file));
    },
    async onFileChangeMultiple(e, item) {
      const file = e.target.files[0];
      const index = this.photos.findIndex((photo) => photo.code === item.code);

      this.enviarBitacora("Capturando fotos de la cámara múltiples");
      this.enviarBitacora(newFile);

      const blob = file.slice(
        0,
        file.size,
        extensionImage.getExtension(file.type)
      );
      const newFile = new File(
        [blob],
        `${this.poliza.RAMO}${this.poliza.NUMPOLIZA}-${this.photos[index].code}.jpeg`
      );

      //console.log(newFile);

      this.photos[index].photo = URL.createObjectURL(file);
      this.photos[index].base = newFile;
    },
    async preparePhotos(cotizacion) {

      let data = new FormData();

      if (this.estatusRenovacion === "0") {
        data.append("files", this.photo.base);
        await this.enviarFoto(data);
        this.enviarInspeccion(cotizacion);
      } else {
        await this.photos.map(async (photo) => {
          data = new FormData();
          data.append("files", photo.base);
          await this.enviarFoto(data);
        });

        this.enviarInspeccion(cotizacion);
      }
    },
    async enviarFoto(data) {
      const payload = {
        metodo: "ENVIARFOTOS",
        data: data,
      };

      this.enviarBitacora("enviando fotos: " + this.polizaMain);
      await this.$store.dispatch("metodoPostMedia", payload).then((_) => {
        const res = this.$store.getters.getRespuestaREST;
      });
    },
    async guardarClienteUnicoEmitir(items) {
      const payload = {
        metodo: "GUARDARCLIENTEUNICOEMITIR",
        data: {
          TipoPersona: this.tipoPersona,
          Nombre: this.nombreCompletoPoliza,
          APaterno: this.tipoPersona === 2 ? "" : this.apellidoPaternoPoliza,
          AMaterno: this.tipoPersona === 2 ? "" : this.apellidoMaternoPoliza,
          FechaNacimiento: this.formatDateBirthday(
            new Date(this.fechaNacimientoPoliza),
            1
          ),
          RFC: this.rfc,
          Cp: this.codigoPostalPoliza,
          Colonia: this.colonia,
          Calle: this.calle,
          NumExt: this.numExterior,
          NumInt: this.numInterior,
          DomicilioPrincipal: "",
          IdRegistroFiscal: this.regimenFiscal,
          Correo: this.correo,
          Telefono: this.telefono,
          IdAgente: this.poliza.CVAGENTE,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.idCliente = response.IdSise;
        this.guardarCambios(items);
      } else {
        this.loading = false;
        return this.$swal("Error", "Ha ocurrido un error");
      }
    },
    enviarInspeccion(cotizacion) {
      const payload = {
        metodo: "ENVIARINSPECCIONRENOVACION",
        data: {
          ApellidoMaterno: this.apellidoMaternoPoliza,
          ApellidoPaterno: this.apellidoPaternoPoliza,
          Email: this.correo,
          Geolocalizacion: `${this.latitud} - ${this.longitud}`,
          Kilometraje: this.kilometraje,
          Marca: this.poliza.INCISO[0].MARCA,
          Modelo: this.poliza.INCISO[0].MODELO,
          Nombre: this.nombreCompletoPoliza,
          NumeroInciso: this.poliza.INCISO[0].INCISO,
          NumeroPoliza: this.poliza.RAMO + cotizacion,
          NumeroRenovacion: this.estatusRenovacion === "0" ? 1 : 2,
          Placa: this.poliza.INCISO[0].PLACA,
          Submarca: this.poliza.INCISO[0].SUBMARCA,
          Telefono: this.telefono,
          VIN: this.poliza.INCISO[0].SERIE,
          claveAgente: localStorage.getItem("userId"),
          clavePromotor: "0",
          clienteUnico: this.poliza.ASEGURADO[0].NUMEROCLIENTE,
          idCatProducto: "3",
          idRamo: this.poliza.RAMO,
          movimiento: "Inspeccion",
          tipoUnidad: this.poliza.INCISO[0].CVTIPVEHICULO,
          tramite: "Anexo",
          vehiculo: this.poliza.INCISO[0].VEHICULO,
          polizaAnterior: `${this.poliza.RAMO}${this.poliza.NUMPOLIZA}`,
        },
      };

      this.enviarBitacora("enviando fotos para la inspeccion: " + this.polizaMain);
      this.$store.dispatch("metodoPostWithoutLoading", payload);

      document.getElementById("btnExitoModal").click();
    },
    enviarBitacora(mensaje) {
      const payload = {
        metodo: "INSERTABITACORA",
        data: {
          MENSAJE: mensaje,
          PROCESO: "ProcesoCotizacionRenovacion",
          SISTEMA: "RenovacionValor"
        },
      };

      this.$store.dispatch("metodoPostWithoutLoading", payload);
    },
  },
  async mounted() {
    this.getMobileOperatingSystem();
  },
};
</script>
<style>
.btn-rounded {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 35px;
  padding-right: 35px;
  border-radius: 50px;
}

.font-white {
  color: white !important;
}

.navbar-custom {
  background-color: #003b71 !important;
}

.btn-primary {
  background-color: #003b71 !important;
}

.btn-outline-primary {
  border-color: #003b71 !important;
  color: #003b71 !important;
}

.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}

.title {
  font-weight: bold !important;
  color: #003b71 !important;
}

.card {
  border: 0px solid;
  border-radius: 15px !important;
}

.border {
  border: 1px solid black !important;
}

.swal2-html-container {
  color: black
}

</style>
